import React from "react";
import { IKImage } from "imagekitio-react";
import {
  nextSubscription,
  getDayDecor,
  getActivePlan,
} from "../../../utils/subscription";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Dialog } from "@headlessui/react";

const ProductAnnualModal = ({
  activeCard,
  isModalEnabled,
  setIsModalEnabled,
  proPlusData,
  bookingProduct,
}) => {
  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [planImage, setPlanImage] = useState(
    "https://img.learntube.ai/public-assets/PRICING/img25.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1659942530309",
  );
  const [currentPlan, setCurrentPlan] = useState("");
  const [billingAmount, setBillingAmount] = useState("");
  const [endDate, setEndDate] = useState("");
  const [upcomingPlans, setUpcomingPlans] = useState("");
  const [features, setFeatures] = useState([]);
  const userPlan = useSelector((store) => store?.userSubscription);
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const freePlanFeatures = [
    { pointer_name: "Included Features in the Plan" },
    { pointer_name: " Access to 1000+ Micro Skills" },
    { pointer_name: "Certifications using Coins" },
    { pointer_name: "Limited Community Access" },
    { pointer_name: "WhatsApp Bot 7 Day Trial" },
  ];

  const validity = Math.floor(
    (userPlan?.current_subscription_expires_at -
      userPlan?.current_subscription_started_at) /
      (1000 * 60 * 60 * 24 * 30),
  );

  console.log("seeDetails", activeCard);
  useEffect(() => {
    const expiryDate =
      new Date(userPlan?.current_subscription_expires_at).getDate() +
      getDayDecor(
        new Date(userPlan?.current_subscription_expires_at).getDate(),
      ) +
      " " +
      months[new Date(userPlan?.current_subscription_expires_at).getMonth()] +
      " " +
      new Date(userPlan?.current_subscription_expires_at).getFullYear();

    setEndDate(expiryDate);

    const nextPlan =
      nextSubscription(
        userPlan?.subscriptions,
        userPlan?.current_subscription_id,
      ) === -1
        ? "No Upcoming Plans"
        : nextSubscription(
            userPlan?.subscriptions,
            userPlan?.current_subscription_id,
          );

    setUpcomingPlans(nextPlan);
    switch (user_role) {
      case 1: {
        setCurrentPlan("LearnTube Free");
        setBillingAmount("Free");
        setFeatures(freePlanFeatures);
        break;
      }
      case 2: {
        setPlanImage(activeCard?.plan_image);
        setCurrentPlan("LearnTube Pro");
        if (validity < 2) {
          setBillingAmount(
            activeCard?.plan_products?.[0]?.cost_details?.final_cost_total,
          );
        } else if (validity >= 2 && validity < 5) {
          setBillingAmount(
            activeCard?.plan_products?.[1]?.cost_details?.final_cost_total,
          );
        } else {
          setBillingAmount(
            activeCard?.plan_products?.[2]?.cost_details?.final_cost_total,
          );
        }
        setFeatures(activeCard?.plan_pointers);
        break;
      }
      case 3: {
        setCurrentPlan("LearnTube Pro+");
        setBillingAmount(proPlusData?.cost);
        setFeatures(proPlusData?.pp_product_pointers);

        break;
      }
      case 4: {
        setPlanImage(activeCard?.plan_image);
        setCurrentPlan("LearnTubeX");
        if (validity < 2) {
          setBillingAmount(
            activeCard?.plan_products?.[0]?.cost_details?.final_cost_total,
          );
        } else if (validity >= 2 && validity < 5) {
          setBillingAmount(
            activeCard?.plan_products?.[1]?.cost_details?.final_cost_total,
          );
        } else {
          setBillingAmount(
            activeCard?.plan_products?.[2]?.cost_details?.final_cost_total,
          );
        }
        setFeatures(activeCard?.plan_pointers);
        break;
      }
      case 6: {
        setPlanImage(activeCard?.plan_image);
        setCurrentPlan("LearnTube Max");
        if (validity <= 2) {
          setBillingAmount(bookingProduct?.cost);
        } else {
          setBillingAmount(
            activeCard?.plan_products?.[0]?.cost_details?.final_cost_total,
          );
        }
        setFeatures(activeCard?.plan_pointers);
        break;
      }
      case 7: {
        setPlanImage(
          "https://img.learntube.ai/public-assets/PRICING/Job_Promotions_1.svg?updatedAt=1681202123864",
        );
        setCurrentPlan("LearnTube Max Trial");
        setBillingAmount("0");
        setFeatures(freePlanFeatures);
        break;
      }
      default:
        break;
    }
  }, []);

  return (
    <Dialog
      open={isModalEnabled}
      onClose={() => {
        setIsModalEnabled(!isModalEnabled);
      }}
      as="div"
      className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="z-10 flex w-11/12 flex-col items-start justify-center rounded-2xl bg-white px-6 py-3 shadow-2xl md:w-2/5  lg:w-[375px]">
        <>
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={planImage}
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
            className="mt-3 h-32 self-center "
          />
          <div className="mt-5 ">
            <h4 className="text-xs  text-stone-500 ">Current Plan</h4>
            <h1 className="mtont-medium text-black">{currentPlan}</h1>
          </div>
          <div className="mt-4 ">
            <h4 className="text-xs  text-stone-500">Billing Amount</h4>
            <h1 className="mt-1 text-sm font-medium text-black">
              {activeCard?.plan_name !== "Downgrade" && "₹"}
              {billingAmount}
            </h1>
          </div>
          {user_role !== 1 && (
            <div className="mt-4 ">
              <h4 className="text-xs text-stone-500">Subscription Ends on</h4>
              <h1 className="mt-1 text-sm font-medium text-black">{endDate}</h1>
            </div>
          )}
          <div className="mt-4 ">
            <h4 className="text-xs text-stone-500">Upcoming Plans</h4>
            <h1 className="mt-1 text-sm font-medium text-black">
              {upcomingPlans}
            </h1>
          </div>
          <div className="mt-4 mb-2  md:mb-4">
            <h4 className="text-xs text-stone-500">
              Included Features in the Plan
            </h4>
            {features?.map((feature) => (
              <h1 className="mt-1 text-sm font-medium text-black">
                {feature?.pointer_name}
              </h1>
            ))}
          </div>
        </>
      </div>
    </Dialog>
  );
};

export default ProductAnnualModal;
